import { RegistrationAttendeeItemCustomResponse } from './registration-attendee-item-custom-response.model';

export class RegistrationAttendeeItem {
  public EventItemId: number;
  public EventItemSignUpId: number;

  public Descr: string;
  public Quantity: number;
  public ExtendedPrice: number;

  public Selected: boolean;

  public AttendeesForItem: number;
  public MaxItemsAvail: number;
  public Sold: number;
  public Remaining: number;
  public MembersOnly: boolean;
  public RestrictForAffiliations: boolean;
  public Expires: boolean;
  public StartDate: Date;
  public EndDate: Date;
  public ShowAsTeaserifRestricted: boolean;
  public TeaserMessage: string;
  public RestrictedMessage: string;
  public MemberPrice: number;
  public NonMemberPrice: number;
  public AllowRelateProfileMemberPrice: boolean;
  public DisplayOrder: number;
  public HasMemberPricing: boolean;
  public PaymentTypeId: number;

  public constructor() {
    this.EventItemId = 0;
    this.EventItemSignUpId = 0;
    this.Descr = '';
    this.Quantity = 0;
    this.ExtendedPrice = 0;

    this.Selected = false;

    this.AttendeesForItem = 0;
    this.MaxItemsAvail = 0;
    this.Sold = 0;
    this.Remaining = 0;
    this.MembersOnly = false;
    this.RestrictForAffiliations = false;
    this.Expires = false;
    this.StartDate = new Date();
    this.EndDate = new Date();
    this.ShowAsTeaserifRestricted = false;
    this.TeaserMessage = '';
    this.RestrictedMessage = '';
    this.MemberPrice = 0;
    this.NonMemberPrice = 0;
    this.AllowRelateProfileMemberPrice = false;
    this.DisplayOrder = 0;
    this.HasMemberPricing = false;
    this.PaymentTypeId = 0;
  }
}
